import React, { ReactElement, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

interface DestinationsParams {
  destinations: string[] | string
  classNamesItems?: string
  locationIcon?: ReactNode
}

export function Destinations(props: DestinationsParams): ReactElement {
  return (
    <div className="flex items-center">
      {props.locationIcon}
      <div className={twMerge('row-start-2 md:text-xs', props.classNamesItems)}>
        {typeof props.destinations === 'string'
          ? props.destinations
          : props.destinations.join(' · ')}
      </div>
    </div>
  )
}
